import { Card, CardContent } from "@/components/ui/card";

export const MarketAnalysis = () => {
  return (
    <div className="prose max-w-none">
      <div className="grid gap-6">
        <MarketSection
          title="Total Addressable Market (TAM)"
          items={[
            "Global Hotel and Resort Industry: $1.5 trillion (2023)",
            "Represents the entire potential market for hospitality services"
          ]}
        />
        <MarketSection
          title="Serviceable Available Market (SAM)"
          items={[
            "Global Hospitality Software Market: $7.16 billion (2023)",
            "Expected to reach $14.72 billion by 2030",
            "CAGR of 10.85% (2024-2030)"
          ]}
        />
        <MarketSection
          title="Saudi Arabia Market Catalysts"
          subsections={[
            {
              title: "Mega Projects",
              items: [
                "NEOM ($500B investment) - Smart city development including tourism facilities",
                "Red Sea Global ($13.3B investment) - Luxury tourism destination",
                "Qiddiya ($8B investment) - Entertainment and tourism mega-project",
                "AMAALA ($8B investment) - Ultra-luxury tourism destination",
                "Al-Ula Development - Cultural and heritage tourism project"
              ]
            },
            {
              title: "Major Events",
              items: [
                "FIFA World Cup 2034 - Selected as host nation",
                "AFC Asian Cup 2027 - Regional football championship",
                "Asian Winter Games 2029 at NEOM",
                "Riyadh Expo 2030 - Expected to attract 40M+ visitors",
                "Annual Formula 1 Saudi Arabian Grand Prix"
              ]
            }
          ]}
        />
        <MarketSection
          title="Target Market Strategy"
          items={[
            "Focus on mid to large-scale hotels and resorts",
            "Initial geographical focus: Saudi Arabia, GCC countries, and EMEA region",
            "Long-term goal: 5% market share ($358M)"
          ]}
        />
      </div>
    </div>
  );
};

interface MarketSectionProps {
  title: string;
  items?: string[];
  subsections?: {
    title: string;
    items: string[];
  }[];
}

const MarketSection = ({ title, items, subsections }: MarketSectionProps) => (
  <div>
    <h4 className="font-medium mb-2">{title}</h4>
    {items && (
      <ul className="list-disc pl-6 space-y-2">
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    )}
    {subsections && (
      <div className="space-y-4">
        {subsections.map((subsection, index) => (
          <div key={index}>
            <h5 className="font-medium text-sm mb-2">{subsection.title}</h5>
            <ul className="list-disc pl-6 space-y-2">
              {subsection.items.map((item, itemIndex) => (
                <li key={itemIndex}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    )}
  </div>
);
